export default {
    data() {
        return {
            colors: [
                'blue',
                'purple',
                'yellow',
                'green',
                'silver'
            ]
        }
    },
    created() {
        // only on accounts listing pages
        if( this.$root.authInfo.users.length === 0 )
        {
            this.$router.push({path: `/login`})
        }
    },
    methods: {
        getColor(index) {
            if( index >= this.colors.length ) {
                return 'silver'
            }

            return this.colors[index]
        }
    }
}
